import DataTableModule from '~/lib/vue/modules/datatable';
import constants from '~/lib/domain/constants';
import format from '~/lib/domain/format';

/**
 * @param {~/lib.foundation.Container} services
 * @return {Object}
 */
export default (services, namespace='datatable') => {

  return DataTableModule.create({
    namespace,
    services,
    columns: [
      {
        label: 'Type',
        value: row => constants.ADDRESS_TYPES[row.type],
      },
      {
        label: 'Address',
        html: row => format.address(row).join('<br>'),
      },
    ],
  });
};
